import { Banner } from "@/components/banner";
import { SNS } from "@/components/sns";
import { AsideBanner, DateSearchBar, Magazine, SpecialDetail, SpecialPreview } from "@/domains/components";
import { useBookingRecoilValue } from "@/shared/client";
import { useGetSpecial, type SpecialInfoResponse } from "@/shared/server";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

export const Specials = () => {
    const { specialIdx } = useParams<string>();
    const option = { enabled: !!specialIdx };

    const { data } = useGetSpecial<SpecialInfoResponse>({ specialIdx: specialIdx ?? "" }, option);
    const bookingEngine = useBookingRecoilValue();

    const { idx } = getDefaultParameters();
    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return data ? (
        <Box w="100%">
            {idx === "2017" && <SNS />}
            <Box position="relative">
                <Banner imgList={data.imgList} catchPraise={data.catchPraise} />
                {!bookingEngine.isGoogleBE && <DateSearchBar isSubMenu />}
            </Box>
            <SpecialDetail specialIdx={specialIdx} />
            <Magazine idx={specialIdx} />
            <AsideBanner isFullImg={false} />
            <SpecialPreview title="SPECIAL PREVIEW" />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
